export default __webpack_public_path__ + "static/media/logo.fdc8e9af.svg";